import { loanInfoCardsWrapperBaseStyles } from '@sharedCR/loanSummary/LoanInfoCards';

export const pageBlockClasses = {
  wrapper: '!p-16 sm:!p-24',
};

const MAX_GROUP_COLUMNS = 4;

export const getGroupWrapperStyles = length => ({
  ...loanInfoCardsWrapperBaseStyles,
  gridTemplateColumns: {
    xs: '1fr',
    md: `repeat(${Math.min(length, MAX_GROUP_COLUMNS)}, 1fr)`,
  },
});

export const groupTitleStyles = {
  marginBottom: '12px',
};

export const groupWrapperOuterStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
};

export const cardStyles = {
  padding: '4px 8px',
};
